(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-alternative-card"] && !Shopify.designMode) return;
  try {
    window.updateVariant = async function (data, product_id, element) {
    if(!data.variantId || !data.variantTitle || !product_id) return;
    const button = document.querySelector(`button[data-product-id="${product_id}"]`);
    const buttons = element.parentElement.querySelectorAll(`.product-btn__add-variant`);
    if (button) {
      try {
        button.disabled = true;
        button.setAttribute('isLoading', 'true');
        const product = JSON.parse(button.getAttribute('data-product'));
        if(product.id == data.variantId) return;

        const priceElement = button.querySelector('#total-price');
        if(priceElement) {
          priceElement.textContent = data.elementPrice;
        }
        if (product) {
          button.setAttribute(
            'data-product',
            JSON.stringify({
              ...product,
              id: `${data.variantId}`,
              variantTitle: `${data.variantTitle}`,
              price: `${data.price}`,
              compare_at_price: `${data.compare_at_price}`,
              stock: `${data.stock}`,
            })
          );
        }

        buttons.forEach(button => {
          button.disabled = false;
          button.classList.remove('active');
        });

        element.classList.add('active');

        
      } catch (error) {
        console.error(error);
      } finally {
        setTimeout(() => {
          button.disabled = false;
          button.removeAttribute('isLoading');
        }, 300);
      }
    }
  };

  window.handleAddToBundle = async function (button) {
    const bundle_product = JSON.parse(button.getAttribute('data-product'));
    if (window.addToBundle && typeof window.addToBundle === 'function') {
      button.disabled = true;
      button.setAttribute('isLoading', 'true');
      window.addToBundle(bundle_product);
      setTimeout(() => {
        button.disabled = false;
        button.removeAttribute('isLoading');
      }, 1000);
    } else {
      if (window.CartAPI && typeof window.CartAPI.addItem === 'function') {
        await window.CartAPI.addItem({
          items: [
            {
              id: bundle_product.id,
              quantity: 1,
            },
          ],
        });
        await window.CartAPI.openCartDrawer();
        await window.CartAPI.buildCart();
      }
    }
  };
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["water-cta"] && !Shopify.designMode) return;
  try {
    const btns = document.querySelectorAll('.water-btn');

  btns.forEach((btn) => {
    btn.addEventListener('mouseenter', (e) => {
      const rect = btn.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;

      createDrop(x, y, btn);
      createRipple(x, y, btn);
      createRings(x, y, btn);
    });
  });

  function createDrop(x, y, btn) {
    const drop = document.createElement('span');
    drop.classList.add('drop');
    drop.style.left = x + 'px';
    drop.style.top = y + 'px';
    btn.appendChild(drop);
    setTimeout(() => drop.remove(), 600);
  }

  function createRipple(x, y, btn) {
    const ripple = document.createElement('span');
    ripple.classList.add('ripple');
    ripple.style.left = x + 'px';
    ripple.style.top = y + 'px';
    btn.appendChild(ripple);
    setTimeout(() => ripple.remove(), 600);
  }

  function createRings(x, y, btn) {
    for (let i = 0; i < 2; i++) {
      const ring = document.createElement('span');
      ring.classList.add('ring');
      ring.style.left = x + 'px';
      ring.style.top = y + 'px';
      ring.style.animationDelay = i * 0.1 + 's';
      btn.appendChild(ring);
      setTimeout(() => ring.remove(), 900);
    }
  }
  } catch(e) { console.error(e); }
})();

})();
